import React, { Fragment } from 'react'
import reduxForm from 'local_modules/redux-form'
import { required } from 'helpers/validation'

import Box from 'components/layout/Box/Box'
import Text from 'components/typography/Text/Text'
import EditableFields from 'components/EditableTable/EditableFields/EditableFields'

import s from './PeriodsForm.scss'


const PeriodsForm = ({ fields, bottom = true, color = 'white', onSubmit, onCancel, submitForm }) => {
  const fieldsRow = [
    {
      fieldType: 'input',
      valueLink: fields.from,
      inputType: 'date',
      calendarOptions: {
        isFutureOnly: false,
        isRange: false,
        bottom,
      },
      fieldName: 'from',
      placeholder: 'с',
      size: 1,
    },
    {
      fieldType: 'input',
      valueLink: fields.to,
      inputType: 'date',
      calendarOptions: {
        isFutureOnly: false,
        isRange: false,
        bottom,
      },
      fieldName: 'to',
      placeholder: 'по',
      size: 1,
    },
  ]

  return (
    <Fragment>
      <EditableFields
        columns={1}
        fieldsRow={fieldsRow}
      />
      <Box
        className={s.button}
        alignCenter
        mt="16"
        onClick={submitForm(onSubmit)}
      >
        <Text
          message="Применить"
          size="18-21"
          color={`${color}-80`}
          weight="semibold"
        />
      </Box>
      <Box
        className={s.button}
        alignCenter
        mt="12"
        onClick={onCancel}
      >
        <Text
          message="Отменить"
          size="18-21"
          color={`${color}-40`}
        />
      </Box>
    </Fragment>
  )
}


export default reduxForm((props) => ({
  fields: {
    from: [ required, (value) => !/^[0-9]{8}$/.test(value) ? 'Не верный формат даты' : null ],
    to: [ required, (value) => !/^[0-9]{8}$/.test(value) ? 'Не верный формат даты' : null ],
  },
}))(PeriodsForm)
